import { render, staticRenderFns } from "./e-tabs.vue?vue&type=template&id=073c420b&scoped=true"
import script from "./e-tabs.vue?vue&type=script&lang=js"
export * from "./e-tabs.vue?vue&type=script&lang=js"
import style0 from "./e-tabs.vue?vue&type=style&index=0&id=073c420b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073c420b",
  null
  
)

export default component.exports